import React, { useState } from "react";
import {
  Popover,
  Chip as initialChip,
  Icon,
  Typography,
} from "@plum-xoxo/admin-dsm";
import { connect } from "react-redux";
import cloneDeep from "lodash/cloneDeep";
import styled from "styled-components";

const Chip = styled(initialChip).attrs()`
  height: 28px;
  background: ${(props) => props.theme.palette.light.c200};
  border-radius: 4px;
  .eui-chip-label {
    padding: 0 8px;
  }
  border: 1px solid ${(props) => props.theme.palette.light.c300};
  .eui-chip-close {
    display: ${(props) => (!props.showDelete ? "" : "none")};
    padding-right: 8px;
  }
`;

const SavedFilters = ({
  initialColumns,
  setColumns,
  savedFilters,
  chipProps,
  setSelectedCategory,
  selectedFilterIndex,
  setSelectedFilterIndex,
  filterLoader,
  applyFilter,
}) => {
  const [selected, setSelected] = useState(false);

  const handleFilterClick = (savedFilter, index) => {
    const newColumns = cloneDeep(savedFilter.tableHeader);
    newColumns.map((column, index) => {
      // for old columns
      if (!column.name) {
        column.name = column.value;
      }
      column.options = initialColumns[index]?.options || {};
    });
    applyFilter(newColumns);
    setSelectedFilterIndex(index);
    document.body.click();
  };

  return (
    <Popover
      width={252}
      onVisibilityChange={(data) => {
        setSelected(data);
      }}
      content={
        <>
          <Popover.Options
            onClick={() => {
              document.body.click();
              applyFilter(initialColumns);
              setSelectedFilterIndex(-1);
            }}
            disabled={filterLoader}
          >
            <Typography color="dark" shade="c300" className="mb-0 ml-20">
              Default
            </Typography>
          </Popover.Options>
          {savedFilters.map((savedFilter, index) => (
            <Popover.Options
              onClick={() => handleFilterClick(savedFilter, index)}
              key={savedFilter.filter_id}
              disabled={filterLoader}
            >
              <Typography
                component="span"
                color={
                  savedFilters[selectedFilterIndex]?.label ===
                  savedFilter?.label
                    ? "primary"
                    : "dark"
                }
                shade={
                  savedFilters[selectedFilterIndex]?.label ===
                  savedFilter?.label
                    ? "c02"
                    : "c300"
                }
                className="mb-0 ml-20"
              >
                {savedFilter.label}
              </Typography>
              {savedFilters[selectedFilterIndex]?.label ===
                savedFilter?.label && (
                <Icon
                  color="primary"
                  shade="c02"
                  component="span"
                  iconName="Right"
                  className="float-right"
                  size={16}
                />
              )}
            </Popover.Options>
          ))}
        </>
      }
      offset={[0, 8]}
      placement="bottom-start"
    >
      <Chip
        {...chipProps[selected ? "active" : "unactive"]}
        textColor="dark"
        textShade="c300"
        label={
          selectedFilterIndex === -1
            ? "Default"
            : savedFilters[selectedFilterIndex]?.label
        }
        size="medium"
        className="mr-8"
        open={selected}
        avatar={
          <div
            className="pl-2"
            style={{
              lineHeight: "0",
            }}
          >
            <Icon iconName="PlumFile" className="ml-8" size={16} />
          </div>
        }
        onDelete={() => {}}
        icon={
          selected ? (
            <Icon iconName="UpperArrow" size={16} />
          ) : (
            <Icon iconName="DownArrow" size={16} />
          )
        }
      />
    </Popover>
  );
};

const mapStateToProps = (state) => {
  const { reportReducer: { filterLoader = false } = {} } = state;
  return {
    filterLoader,
  };
};

export default connect(mapStateToProps)(SavedFilters);
